<script>
  import { onMount } from "svelte";

  let url = "https://www.allinemenezes.com.br";
  let size = 300;
  let displayUrl = url;
  let qrcodeContainer;
  let copyMessage = "Copiar URL";

  let qr; // instância do QRCode

  // Garante que a lib foi carregada
  function ensureQRCodeLibLoaded() {
    return new Promise((resolve, reject) => {
      if (window.QRCode) return resolve();
      const script = document.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js";
      script.onload = () => resolve();
      script.onerror = () => reject("Erro ao carregar QRCode.js");
      document.head.appendChild(script);
    });
  }

  async function makeQRCode(text, size) {
    await ensureQRCodeLibLoaded();
    if (!qrcodeContainer) return;
    qrcodeContainer.innerHTML = "";
    qr = new QRCode(qrcodeContainer, {
      text,
      width: size,
      height: size,
      correctLevel: QRCode.CorrectLevel.H,
    });
    displayUrl = text;
  }

  async function gerar() {
    const text = url.trim();
    const px = Math.max(80, Math.min(1000, parseInt(size) || 300));
    if (!text) {
      alert("Insira uma URL válida.");
      return;
    }
    await makeQRCode(text, px);
  }

  async function copiar() {
    try {
      await navigator.clipboard.writeText(url);
      copyMessage = "Copiado!";
      setTimeout(() => (copyMessage = "Copiar URL"), 1500);
    } catch {
      alert("Não foi possível copiar. Copie manualmente: " + url);
    }
  }

  async function baixar() {
    const text = url.trim();
    const px = Math.max(80, Math.min(1000, parseInt(size) || 300));
    if (!text) return alert("Insira uma URL válida.");
    await ensureQRCodeLibLoaded();

    const tmp = document.createElement("div");
    const tmpQr = new QRCode(tmp, {
      text,
      width: px,
      height: px,
      correctLevel: QRCode.CorrectLevel.H,
    });

    setTimeout(() => {
      const img = tmp.querySelector("img");
      const cvs = tmp.querySelector("canvas");

      if (cvs) {
        const dataURL = cvs.toDataURL("image/png");
        triggerDownload(dataURL, "qrcode.png");
      } else if (img) {
        triggerDownload(img.src, "qrcode.png");
      } else {
        alert("Falha ao gerar QR.");
      }
      tmp.innerHTML = "";
    }, 50);
  }

  function triggerDownload(dataUrl, filename) {
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  onMount(() => {
    makeQRCode(url, size);
  });
</script>

<style>
  :global(body) {
    background: #f7fafc;
    color: #0f172a;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  }

  .card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(10, 20, 40, 0.06);
    padding: 1.25rem;
    width: 360px;
    margin: 2rem auto;
  }

  h1 {
    font-size: 1.1rem;
    margin: 0 0 0.75rem 0;
  }

  label {
    display: block;
    font-size: 0.85rem;
    margin-top: 0.6rem;
    color: #334155;
  }

  input {
    width: 100%;
    padding: 0.5rem;
    margin-top: 0.35rem;
    border-radius: 8px;
    border: 1px solid #e6edf3;
    font-size: 0.95rem;
    box-sizing: border-box;
  }

  .row {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.75rem;
  }

  button {
    padding: 0.6rem 0.9rem;
    border-radius: 8px;
    border: 0;
    background: #0ea5a4;
    color: white;
    cursor: pointer;
    font-weight: 600;
  }

  button.secondary {
    background: #64748b;
  }

  .preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    margin-top: 1rem;
    padding: 0.75rem;
    border-radius: 8px;
    border: 1px dashed #e2e8f0;
    background: #fbfeff;
  }

  #qrcode {
    padding: 8px;
    background: white;
    border-radius: 6px;
  }

  small {
    color: #475569;
  }

  .note {
    font-size: 0.85rem;
    color: #475569;
    margin-top: 0.6rem;
  }
</style>

<div class="card">
  <h1>Gerador de QR Code</h1>

  <label for="url">URL</label>
  <input id="url" bind:value={url} type="text" />

  <label for="size">Tamanho (px)</label>
  <input id="size" bind:value={size} type="number" min="80" max="1000" />

  <div class="row">
    <button on:click={gerar}>Gerar</button>
    <button class="secondary" on:click={baixar}>Baixar PNG</button>
    <button class="secondary" on:click={copiar}>{copyMessage}</button>
  </div>

  <div class="preview">
    <div bind:this={qrcodeContainer} id="qrcode"></div>
    <small>QR Code para <strong>{displayUrl}</strong></small>
  </div>

  <p class="note">
    Dica: abra a câmera do celular e aponte para o QR para testar.
  </p>
</div>
